import "regenerator-runtime";
import '@/styles/app.scss';
import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router';
import i18n from './i18n';
import store from '@/store';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { createProvider, onLogin, onLogout, AUTH_TOKEN } from '@/apollo/vue-apollo';
import { Auth0Plugin, getInstance } from "./auth";
import 'vue-tel-input/dist/vue-tel-input.css';

Vue.use(VueMeta, {
  titleTemplate: '%s | eKitabu',
})

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

import '@/mixins/currencyMixins';

import EkitabuSelect from '@/components/EkitabuSelect.vue'
Vue.component('EkitabuSelect', EkitabuSelect)

import EkitabuButton from '@/components/EkitabuButton.vue'
Vue.component('EkitabuButton', EkitabuButton)

import { Loader } from "@googlemaps/js-api-loader";

// setup google maps api
const loader = new Loader({
  apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
  version: "weekly",
});

loader.load().then(async () => {
  const { Map } = await google.maps.importLibrary("places");
});

const domain = process.env.VUE_APP_AUTH0_DOMAIN;
const clientId = process.env.VUE_APP_AUTH0_CLIENT_ID;
const audience = process.env.VUE_APP_AUTH0_AUDIENCE;

const apolloProvider = createProvider();

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  responseType: 'token id_token',
  audience: audience,
  scope: 'openid profile email',
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

const instance = getInstance();
if (instance.isE2EFake) {
  // LOCAL/TEST ONLY: log in immediately with the dummy token (no Auth0 round-trip).
  instance.getTokenSilently().then(token => {
    onLogin(apolloProvider.defaultClient, token, instance.user.sub);
  });
} else {
  instance.$watch("loading", async loading => {
    if (!loading && instance.isAuthenticated) {
      const token = await instance.getTokenSilently();
      onLogin(apolloProvider.defaultClient, token, instance.user.sub);
    } else if (!loading) {
      // Only reset the store if there was a previous session to clear.
      // Avoids "Store reset while query was in flight" on cold start.
      const hadToken = localStorage.getItem(AUTH_TOKEN);
      if (hadToken) {
        onLogout(apolloProvider.defaultClient);
      }
    }
  });
}

import EkitabuImage from "@/components/EkitabuImage";
Vue.component("EkitabuImage", EkitabuImage);

import EkitabuChip from "@/components/EkitabuChip";
Vue.component("EkitabuChip", EkitabuChip);

import EkitabuIcon from "@/components/EkitabuIcon";
Vue.component("EkitabuIcon", EkitabuIcon);

import EkitabuProgressCircular from "@/components/EkitabuProgressCircular";
Vue.component("EkitabuProgressCircular", EkitabuProgressCircular);

import EkitabuDialog from "@/components/EkitabuDialog";
Vue.component("EkitabuDialog", EkitabuDialog);

import EkitabuDataTable from "@/components/EkitabuDataTable";
Vue.component("EkitabuDataTable", EkitabuDataTable);

import EkitabuExpansionPanel from "@/components/EkitabuExpansionPanel";
Vue.component("EkitabuExpansionPanel", EkitabuExpansionPanel);

import EkitabuTabs from "@/components/EkitabuTabs";
Vue.component("EkitabuTabs", EkitabuTabs);

import EkitabuTabItem from "@/components/EkitabuTabItem";
Vue.component("EkitabuTabItem", EkitabuTabItem);

import EkitabuStepper from "@/components/EkitabuStepper";
Vue.component("EkitabuStepper", EkitabuStepper);

Vue.config.productionTip = false

export default new Vue({
  vuetify,
  router,
  i18n,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
